import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import 'moment/locale/es'
import { connect } from 'react-redux'

import momentLocalizer from 'react-widgets-moment'
import DatePickerUI from './../../../components/DatePickerUI'
import SelectUI from './../../../components/SelectUI'
import Autocomplete from 'react-google-autocomplete'

import _ from 'underscore'
import { Row, FormGroup } from 'react-bootstrap'
import { FormControl as FormControlUi } from 'material-ui/Form'

import { Field, reduxForm, change, touch } from 'redux-form'
import { InputLabel } from 'material-ui/Input'

import { selectNewDate, selectScheduleRange, geolocateAddress, setPickupAddress } from './actions'
import { fetchAvailableHours, fetchAvailableAdvisors, cleanAdvisorStore, setSelectedDateAndTime } from './actions'
import validation from './../../../constants/validation'
import { holidays } from './../../../constants/holidays'

import AddressMap from './addressMap'

import { configuration } from './../../../configuration'
import Swal from 'sweetalert2'

const validate = (values) => {
  const errors = { appointment: {} }
  const appointment = values.appointment || {};

  if ((!appointment.date || appointment.date === '')/*  && !appointment.noAppointment */) {
    errors.appointment.date = validation.REQUIRED_FIELD;
  }
  if ((!appointment.time || appointment.time === '') /* && !appointment.noAppointment */) {
    errors.appointment.time = validation.REQUIRED_FIELD;
  }

  if (Object.keys(errors.appointment).length === 0) {
    delete errors.appointment;
  }
  return errors;
};

const onSubmit = (values, dispatch, props) => {
  console.log("SUBMIT: ", values)
};

const form = reduxForm({
  form: 'appointmentDataForm',
  validate,
  onSubmit
});

class AppointmentCalendar extends React.Component {

  static propTypes = {
    appointmentStore: PropTypes.shape({
      canRedirect: PropTypes.bool.isRequired,
      appointmentData: PropTypes.object,
      tempAppointmentData: PropTypes.object
    }),
    selectNewDate: PropTypes.func.isRequired,
    selectScheduleRange: PropTypes.func.isRequired,
    error: PropTypes.shape({
      scheduleRangeError: PropTypes.bool,
    }),
  };

  state = {
    workshopAddress: (this.props.workshop.address) ? this.props.workshop.address : '',
    hours: false, // false means not fetched
    selectedDate: null,
    selectedTime: null,
    pickupAddress: null,
    pickupCP: null,
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleScheduleRange = this.handleScheduleRange.bind(this);
  }

  componentWillMount() {

    this.props.setPickupAddress(null)

    if (this.props.selectedDate !== false && this.props.selectedTime !== false) {
      const date = moment(this.props.selectedDate).toISOString();
      const time = this.props.selectedTime;
      this.setState({
        selectedDate: date,
        selectedTime: time,
      })
      if (!this.props.appointmentStore.showDatePickerUIContent) {
        this.props.loadFormValues('appointmentDataForm', 'appointment.date', '')
        this.props.loadFormValues('appointmentDataForm', 'appointment.time', '')
      } else {
        this.props.loadFormValues('appointmentDataForm', 'appointment.date', this.props.selectedDate)
        this.props.loadFormValues('appointmentDataForm', 'appointment.time', this.props.selectedTime)
      }
      let appointmentdate = moment(this.props.selectedDate)
      this.setState({
        selectedDate: appointmentdate,
      })
      this.props.fetchAvailableHours(date, configuration().workshopEmailHash);
      this.props.fetchAvailableAdvisors(date, time, null, configuration().workshopEmailHash);
    }
  }

  handleChange(newDate) {
    this.props.selectNewDate(newDate);
    this.props.fetchAvailableHours(moment(newDate).startOf('day').toISOString(), configuration().workshopEmailHash);
  }

  handleScheduleRange(newRange) {
    this.props.selectScheduleRange(newRange);
    this.props.fetchAvailableAdvisors(this.props.appointmentStore.tempAppointmentData.date, newRange, null, configuration().workshopEmailHash);
  }

  handleUrgency = () => {
    this.props.selectScheduleRange('URGENCY');
  };


  handleDateChange = (value) => {
    if (!configuration().allowTodayAppointments && moment(value).dayOfYear() === moment().dayOfYear()) {
      return
    }

    this.props.cleanAdvisorStore(['hours', 'advisors', 'selectedTime']) // reset select options
    this.props.fetchAvailableHours(moment(value).toISOString(), configuration().workshopEmailHash);
    this.setState({
      selectedDate: moment(value),
    })
  };

  handleHourChange = (event) => {
    this.props.cleanAdvisorStore(['advisors']) // reset select options
    this.props.fetchAvailableAdvisors(this.state.selectedDate.toISOString(), event.target.value, null, configuration().workshopEmailHash);
    this.props.setSelectedDateAndTime(this.state.selectedDate, event.target.value);
    // Vemos si tenemos que mostrar el modal de aviso de limite de hora para entrega en el dia
    if (this.props.workshop.limitHour && (event.target.value >= this.props.workshop.limitHour)) {
      Swal.fire(
        {
          text: 'A partir de las ' + this.props.workshop.limitHour + ' horas es posible que su vehículo no pueda ser reparado en el mismo día y por lo tanto no pueda ser retirado hasta el día siguiente.',
          confirmButtonClass: 'jump button-primary',
        }
      ).then(() => { return null })
    }
    this.setState({
      selectedTime: event.target.value
    })
  };

  handleSubmit() {
    if (this.props.appointmentDataForm.syncErrors) {
      _.each(Object.keys(this.props.appointmentDataForm.syncErrors), (field) => {
        this.props.touchFormField('appointmentDataForm', field);
      });
    }
    this.props.handleSubmit;
  }

  createNewTempHoursRange = (availableHours) => {
    var tempdateHours = []
    _.each(availableHours, (hour) => {
      if (hour > moment().format('HH:mm')) {
        tempdateHours.push({ 'label': hour, 'value': hour })
      }
    })
    return tempdateHours
  }

  shouldDisableDate = (momentDate) => {
    const weekDay = momentDate.isoWeekday();
    const dayOfYear = moment(momentDate).dayOfYear();
    const today = moment().dayOfYear()
    const tomorrow = moment().add(1, 'days').dayOfYear()

    // Primero comprobamos directamente con los dias con huecos ocupados.
    if (this.props.appointmentStore.emptyDates && this.props.appointmentStore.emptyDates.includes(momentDate.format('YYYY-MM-DD'))) return true
    
    return (
      configuration().weekDays.includes(weekDay)
      || holidays(this.props.workshop.holidays).includes(dayOfYear)
      || (today === dayOfYear && !configuration().allowTodayAppointments)
      || (tomorrow === dayOfYear && !configuration().allowTomorrowAppointments)
    );
  };

  handlePickupAddress = value => {
    console.log(value)
    this.setState({
      pickupAddress: value.formatted_address
    })

    this.props.geolocateAddress(this.state.pickupAddress)
    this.props.setPickupAddress(this.state.pickupAddress)
  }
  handlePickupCP = ({ target: { value } }) => {
    this.setState({
      pickupCP: value
    })
  }

  handleKeyPressSearch = (event) => {
    if (event.key === 'Enter') {
      this.props.geolocateAddress(this.state.pickupAddress + ', ' + this.state.pickupCP)
      this.props.setPickupAddress(this.state.pickupAddress + ', ' + this.state.pickupCP)
    }
  }

  render() {
    const hours = this.props.hours;
    const appointmentData = this.props.appointmentStore.appointmentData || {};
    const tempAppointmentData = this.props.appointmentStore.tempAppointmentData || {};

    const currentDate = moment();
    currentDate.startOf('day');
    currentDate.add(2, 'days');
    if (currentDate.isoWeekday() === 4) {
      currentDate.add(1, 'days');
    }

    const scheduleRange = appointmentData.scheduleRange;
    const tempScheduleRange = tempAppointmentData.scheduleRange;
    const tempDate = new Date(tempAppointmentData.date);

    const error = this.props.appointmentStore.error || {};

    let renderMap = '';
    let renderInfo = '';
    let renderError = '';
    let renderAddressForm = '';

    const autocareAddress = this.state.workshopAddress;

    let filteredHours = [];

    if (moment(this.state.selectedDate).isSame(moment().startOf('day'))) {
      filteredHours = _.filter(hours, function (o) {
        const hourMinutes = o.split(":")
        const hour = hourMinutes[0]
        const minute = hourMinutes[1]
        const dayHourMinute = moment().startOf('day').set('hour', hour).set('minute', minute);
        return dayHourMinute.isAfter(moment());
      })

    } else {
      filteredHours = hours
    }

    var hoursOptions = []
    //COMPROBAR SI HAY UN VEHICULO DE SUSTITUCION PEDIDO
    //SI HAY VEHICULO DE SUSTITUCION PEDIDO, RESTRINGUIR LAS HORAS SI ES NECESARIO
    if (this.props.appointmentStore.hours && this.state.selectedDate && this.props.appointmentStore.replacementVehicle) {
      let currentDay = moment()
      let selectedDay = this.state.selectedDate

      //Estoy en un margen de 2 dias por lo que tengo que restringir las horas
      let isFriday = moment().day() == 5
      let isThursday = moment().day() == 4
      if ((selectedDay.diff(currentDay, 'days') < 2) || ((isFriday || isThursday) && selectedDay.diff(currentDay, 'days') < 4)) {
        hoursOptions = this.createNewTempHoursRange(this.props.appointmentStore.hours)
      } else {
        hoursOptions = Array.isArray(filteredHours) ? filteredHours.map(e => ({ label: e, value: e })) : []
      }
    } else {
      hoursOptions = Array.isArray(filteredHours) ? filteredHours.map(e => ({ label: e, value: e })) : []
    }


    if (_.find(this.props.shoppingCart.items, (item) => { return item.name === configuration().servicioRecogidaYEntrega })) {
      renderAddressForm =
        <div>
          <span className='direccion_recogida_titulo'>Por favor, introduzca la dirección donde recogeremos su coche (casa u oficina)</span>
          <div className="row" style={{ marginTop: 15, paddingBottom: 15 }}>
            <FormGroup bsClass="col-8" controlId="pickupAddress">
              <Autocomplete
                className="inputAddress"
                onPlaceSelected={(place) => {
                  this.handlePickupAddress(place)
                }}
                types={['address']}
                componentRestrictions={{ country: "es" }}
                placeholder="Dirección (Calle, número, municipio)"
              />
            </FormGroup>
          </div>
          <br />
          <AddressMap latLng={_.isEmpty(this.props.appointmentStore.latLng) ? { lat: this.props.workshop.lat, lng: this.props.workshop.lon } : this.props.appointmentStore.latLng} />
        </div>
    } else {
      renderAddressForm =
        <div>
          <span className='direccion_taller_titulo'>{configuration().topAddressText ? configuration().topAddressText : 'Esta es la dirección del taller donde debe llevar su vehículo.'}</span>
          <br />
          <br />
          <p className="direccion_taller_text col-12">
            {autocareAddress}
          </p>
          <br />
          <AddressMap latLng={{ lat: this.props.workshop.lat, lng: this.props.workshop.lon }} />
        </div>
    }

    if (this.props.appointmentStore.latLng && this.props.appointmentStore.latLng.lat && this.props.appointmentStore.latLng.lng) {
      renderMap = (
        <React.Fragment>
          <AddressMap latLng={this.props.appointmentStore.latLng || {}} />
        </React.Fragment>
      );
    }

    if (tempScheduleRange === 'URGENCY') {
      renderInfo = (
        <p className="text-warning" style={{ marginTop: '10' }}>¡Recibido! Tras finalizar el formulario te contactaremos lo antes posible.</p>
      );
    } else {
      let onCurrentDay = _.every(this.props.shoppingCart.items, (item) => !_.isUndefined(item.onCurrentDay) && _.contains(item.onCurrentDay, tempScheduleRange));
      if (onCurrentDay) {
        renderInfo = (
          <p className="text-warning" style={{ marginTop: '10' }}>¡Recibido! Tendrás tu coche terminado de 16:00 a 18:00 hrs. salvo que acordemos un horario previamente.</p>
        );
      }
    }

    if (this.props.errors && this.props.errors.scheduleRangeError && !tempScheduleRange) {
      renderError = (
        <p className="text-danger">Debe seleccionar una hora para la cita</p>
      );
    }
    moment.locale('es')
    momentLocalizer()
    let friday = moment().day() == 5
    var minDateValue = friday ? moment().startOf('day').add(4, 'days') : moment().startOf('day').add(1, 'days')
    if (configuration().allowTodayAppointments) {
      minDateValue = moment().startOf('day')
    }
    return (
      <React.Fragment>
        <Row>
          <form onSubmit={() => this.handleSubmit()} className="col-12" >
            <Row>
              <div className="col-md-6 col-sm-12" style={{ marginTop: -5, marginBottom: '20px' }}>
                <Field
                  label="Selecciona el día"
                  component={DatePickerUI}
                  disablePast={true}
                  minDate={minDateValue}
                  name="appointment.date"
                  shouldDisableDate={this.shouldDisableDate}
                  disabled={false}
                  onChange={this.handleDateChange}
                />
              </div>
              <div className="col-md-6 col-sm-12" style={{ marginTop: -5 }}>
                <FormControlUi className="w-100 mb-2">
                  <InputLabel htmlFor="hour">Horas</InputLabel>
                  {
                    hours.length === 0 ? 
                    <span>Sin horas disponibles</span> : <Field
                      component={SelectUI}
                      name="appointment.time"
                      options={hoursOptions}
                      disabled={hours === false}
                      onChange={this.handleHourChange}
                    />
                  }
                  
                </FormControlUi>
              </div>
            </Row>
          </form>
        </Row>
        <br />
        <div className="dividerLine"></div>
        {renderAddressForm}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  appointmentStore: state.checkout.appointment,
  shoppingCart: state.checkout.shoppingCart,
  workshop: state.checkout.workshop,
  hours: state.checkout.appointment.hours,
  advisors: state.checkout.appointment.advisors,
  refreshFromHours: state.checkout.appointment.refreshFromHours,
  selectedDate: state.checkout.appointment.selectedDate,
  selectedTime: state.checkout.appointment.selectedTime,
  appointmentDataForm: state.form.appointmentDataForm || {}
})

const bindActions = dispatch => ({
  selectNewDate: newDate => dispatch(selectNewDate(newDate)),
  selectScheduleRange: newRange => dispatch(selectScheduleRange(newRange)),
  fetchAvailableHours: (date, autocare) => dispatch(fetchAvailableHours(date, autocare)),
  fetchAvailableAdvisors: (date, time, budgetId, workshopEmailHash) => dispatch(fetchAvailableAdvisors(date, time, budgetId, workshopEmailHash)),
  cleanAdvisorStore: props => dispatch(cleanAdvisorStore(props)),
  loadFormValues: (form, field, value) => dispatch(change(form, field, value)),
  touchFormField: (form, field) => dispatch(touch(form, field)),
  setSelectedDateAndTime: (date, time) => dispatch(setSelectedDateAndTime(date, time)),
  geolocateAddress: (address) => dispatch(geolocateAddress(address)),
  setPickupAddress: (address) => dispatch(setPickupAddress(address))
})

export default connect(mapStateToProps, bindActions)(form(AppointmentCalendar))


// WEBPACK FOOTER //
// ./src/workflow/checkout/appointment/appointmentCalendar.component.js